(function(window, document, $, undefined){

  notPlayed = true;


  function getWidth(){
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return w;
  }


  function move_threat_status(){

    var status = $('.threat-status').attr('data-threat-status');
    var element = $('.threat-status .status_'+status);
    var marker = $('.threat-status h3');

    if(getWidth()<992){
      $('.threat-status').addClass('vertical');
      var pos = element.position().top;
      pos = pos - (marker.outerHeight() / 2) + (element.outerHeight() / 2);
      TweenMax.to(marker,1,{css:{top:(pos-3),opacity:1,left:0},ease:Power2.easeOut});
    } else {
      $('.threat-status').removeClass('vertical');
      var pos = element.position().left;
      pos = pos - (marker.outerWidth() / 2) + (element.outerWidth() / 2);
      TweenMax.to(marker,1,{css:{left:pos,opacity:1,top:-58},ease:Power2.easeOut});
    }


    notPlayed = false;
  }

  if($('.threat-status').length){

    $('.threat-status').on('inview', function(event, visible) {
        if (visible && notPlayed) {
          move_threat_status();
          // TweenMax.to(marker,1,{css:{left:pos,opacity:1},ease:Power2.easeOut});
            //in view
        } else {
            //out view
        }
    });



    var threatStatusResizeHandler = debounce(function(){
      move_threat_status();
    },100);
    $(window).on("resize", threatStatusResizeHandler);




  }

})(window, document, jQuery);